import { Component, ViewChild, OnInit, Output, ViewEncapsulation, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository, WindowRef } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {
  Lists_loaikhoan, Lists_tieumuc, Lists_nguonkinhphi, Lists_danhmuccapdonvi
  , Ultil_donvi
} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'

import { DomSanitizer } from '@angular/platform-browser';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';


import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';



const swal = require('sweetalert');
@Component({
  selector: 'app-nhaplieu-giayphepedit',
  templateUrl: './giayphepedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./giayphepedit.component.scss'],
  providers: [ListService, Repository, WindowRef],
  encapsulation: ViewEncapsulation.None
})


export class giayphepeditComponent implements OnInit {
  @ViewChild('modal', { static: false }) modal: ModalComponent;
  @ViewChild('dteChung', { static: false }) doituongchungedit: any;
  @ViewChild('modalchondonvicaptren', { static: false }) modalchondonvicaptren: ModalComponent;
  @ViewChild('dtechondonvicaptren', { static: false }) dtechondonvicaptren: any;
  inputnoicaps: any;
  inputdonvis: any;
  inputloaigiaypheps: any;
  inputnhomgiaypheps: any;
  public ngaybatdau: Date = null;
  public ngayketthuc: Date = null;

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputloaicauhois: any
  indLoading: boolean = false;
  doituongSelect: any = {
     Id: null,
    DonViId: null, DonViCapId: null,
      SoGiayPhep: null,
      NgayCap: null,
      NgayHetHan: null,
      Loai: null,
      LoaiGiayPhepId: null,
      GhiChu: null,
      NgayThuHoi: null,
      LyDoThuHoi: null
    , Created: null
    , CreatedBy: null
    , Modified: null
    , ModifiedBy: null

  };
  nhomdtid: string = null;
  hoatdong: string = null;
  inputloais: any = [{ Id: 0, Ten: 'Đúng sai' }, { Id: 1, Ten: 'Một lựa chọn' }, { Id: 2, Ten: 'Nhiều lựa chọn' }, { Id: 3, Ten: 'Tự luận' }]

  inputhinhthucthanhtoans: any = [{ Id: 0, Ten: 'Thanh toán tại nhà' }, { Id: 1, Ten: 'Chuyển khoản' }]

  inputmonhocs: any;
  inputloaikhoanluongs: any = [{ Id: 1, Name: 'Thu nhập thường xuyên' }, { Id: 2, Name: 'Thu nhập không thường xuyên' }, { Id: 3, Name: 'Khấu trừ thường xuyên' }, { Id: 4, Name: 'Khấu trừ không thường xuyên' }]
  inputloaikieunhaps: any = [{ Id: 1, Name: 'Số tiền' }, { Id: 2, Name: 'Tỷ lệ (%)' }, { Id: 3, Name: 'Hệ số' }]
  inputloaikhoans: any;
  inputloaithis: any;
  inputtaikhoantaisans: any;
  inputmucdocauhois: any;
  inputtinhs: any;
  inputhuyens: any;
  inputxas: any;

  file: any;
  idnew: string;
  hienthianh: any;

  @Output() save: EventEmitter<any> = new EventEmitter();

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  constructor(private _dataService: ListService, public repo: Repository, private sanitizer: DomSanitizer) {


  }
  transformYourHtml(htmlTextWithStyle) {
    return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
  }
  ngOnInit(): void {
    //document.getElementById('target').classList.add('upload-dialog1');
    //document.getElementById('defaultfileupload').style.display = 'none';
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngAfterViewInit() {
    //setTimeout(() => {
    //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
    //  this.rteObj.toolbarModule.refreshToolbarOverflow();
    //}, 400);
  } 




  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  public dviid: string;
  bledit: boolean = false;
  currentUser: any;
  tudanhsach: number;
  khoahocid: number;

  
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, noicapid: number, tudanhsach: number) {
    this.tudanhsach = tudanhsach;
    
    //this.repo.postRequest("api/khoahoc/gettinh/", { Id: 1 })
    //  .subscribe(response => {
    //    this.inputtinhs = response;
    //  });


    this.dviid = donviid;
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {
      let data = JSON.parse(authlogin);
      this.currentUser = data;
      var giatri = data.ds_quyen.filter(name => name.Id === Lists_danhmuccapdonvi.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);

    //this.doituongSelect.AnhString = null;
    this.hienthianh = false;
    $('#preview').attr('src', "/assets/img/anhdt.gif");

    this.repo.postRequest("api/kybaocao/getnhomgiayphep/", { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.inputnhomgiaypheps = response;
      });
    this.repo.postRequest("api/kybaocao/getloaigiayphep/", { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.inputloaigiaypheps = response;
      });

    this.repo.postRequest("api/baselayout/DonViChaPhanQuyen_GiayPhep2_Read", { UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.inputdonvis = response;
      });

    this.repo.postRequest("api/donvibanle/getnoicap/", { Id: id, UserName: this.currentUser.user_name })
      .subscribe(response => {
        this.inputnoicaps = response;
      });
    

    this.doituongSelect = {
      Id: null,
      DonViId: null, DonViCapId: noicapid,
      SoGiayPhep: null,
      NgayCap: null,
      NgayHetHan: null,
      Loai: null,
      LoaiGiayPhepId: null,
      GhiChu: null,
      NgayThuHoi: null,
      LyDoThuHoi: null
      , Created: null
      , CreatedBy: null
      , Modified: null
      , ModifiedBy: null


    };
    this.ngaybatdau = null;
    this.ngayketthuc = null;

    if (donviid != null)
      this.doituongSelect.DonViId = parseInt(donviid);
    else
      this.doituongSelect.DonViId = parseInt(this.currentUser.id_don_vi);

    this.doituongSelect.DonViCapId = noicapid;

    this.repo.postRequest("api/giayphep/getthongtindonviid/", { DonViId: this.doituongSelect.DonViId })
      .subscribe(response => {
        if (response != null) {
          this.doituongSelect.DonVi = response.TenTiengNuocNgoai;
        }
        this.modalchondonvicaptren.close();
      });

    
    if (id === null) {

      this.bledit = false;
      this.doituongSelect.Created = new Date();
      this.doituongSelect.Modified = new Date();
      if (this.currentUser !== null) {
        this.doituongSelect.CreatedBy = this.currentUser.user_name;
        this.doituongSelect.ModifiedBy = this.currentUser.user_name;
      }

      this.doituongSelect.TrangThai = true;

      

    }
    else {
      this.bledit = true;
      console.log("t11");
      this.repo.getRequest("api/giayphep/getmodel/" + id)
        .subscribe(response => {
          this.doituongSelect.Id = id;

          this.doituongSelect.SoGiayPhep = response.SoGiayPhep;
          this.doituongSelect.DonViId = response.DonViId;
          this.doituongSelect.DonVi = response.DonVi;
          this.doituongSelect.DonViCapId = response.DonViCapId;
          this.doituongSelect.SoGiayPhep = response.SoGiayPhep;
          if (response.NgayCap != null)
            this.doituongSelect.NgayCap = new Date(response.NgayCap);
          else
            this.doituongSelect.NgayCap =null;
          if (response.NgayHetHan != null)
            this.doituongSelect.NgayHetHan = new Date(response.NgayHetHan);
          else
            this.doituongSelect.NgayHetHan = null;

          
          
          this.doituongSelect.Loai = response.Loai;
          this.doituongSelect.LoaiGiayPhepId = response.LoaiGiayPhepId;
          this.doituongSelect.GhiChu = response.GhiChu;
          if (response.NgayThuHoi != null)
            this.doituongSelect.NgayThuHoi = new Date(response.NgayThuHoi);
          else
            this.doituongSelect.NgayThuHoi = null;
          this.doituongSelect.LyDoThuHoi = response.LyDoThuHoi;
          

          if (response.Created != null)
            this.doituongSelect.Created = new Date(response.Created);
          else
            this.doituongSelect.Created = new Date();
          this.doituongSelect.CreatedBy = response.CreatedBy;

          
          if (response.Modified != null)
            this.doituongSelect.Modified = new Date(response.Modified);
          else
            this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = response.ModifiedBy;

          //setTimeout(() => {
          //  this.rteObj.refreshUI(); // làm editor render lại hoàn toàn
          //  this.rteObj.toolbarModule.refreshToolbarOverflow();
          //}, 400);



        });
    }

  

  }

  adddatachondoituongchung(index: number) {
    let donvi = '234,235,236,248,256,257';
    this.dtechondonvicaptren.loadDataInit(null, null, "03", donvi, null, 1);
    this.modalchondonvicaptren.open();
  }
  savedsdoituongchung(doituong: any) {
    let i = 0;
    if (doituong != null) {
      doituong.forEach(
        (item) => {
          if (i == 0) {
            this.doituongSelect.DonViId = item.Id;
            this.doituongSelect.DonVi = item.Ma + " - " + item.Ten;
            this.modalchondonvicaptren.close();
          }

        }
      );
    }
    else {
      this.doituongSelect.DonViId = null;
      this.doituongSelect.DonVi = null;
      this.modalchondonvicaptren.close();
    }
  }
  

  adddata_donvi() {

    this.doituongchungedit.loadDataInit(Ultil_donvi.id, null, this.dviid);
    this.modal.open();
  }
  saveModal(doituong: any) {
    if (doituong != null) {
      this.inputdonvis.push({
        Id: doituong.Id, Ten: doituong.Ten, Ma: doituong.Ma
      })
      this.inputdonvis = this.inputdonvis.slice();
      this.doituongSelect.DonViId = doituong.Id;
    }
    this.modal.dismiss();
  }

  Tai_Anh() {

    this.doituongSelect.XoaAnh = 1;
    $("#File").click();
  }
  Xoa_Anh() {

    this.doituongSelect.XoaAnh = 0;
    $('#preview').attr('src', "/assets/img/anhdt.gif");
  }
  getFiles(event) {
    console.log("tt");
    //console.log(event);
    this.file = event.target.files;
    if (!this.file[0].type.match("image.*")) {
      alert("Tệp chọn không phải kiểu ảnh.");
      event.srcElement.value = null;
      return;
    }

    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(this.file[0]);

  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.doituongSelect.AnhString = btoa(binaryString);  // Converting binary string data.

    $('#preview').attr('src', "data:image/png;base64," + this.doituongSelect.AnhString + "");

  }
  //  keyTenPress(event: any) { 
  //      if (event.which === 13) {
  //        this.slLoaiKhoanLuong.focus();
  //          event.preventDefault();
  //        }
  //}

  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    
    this.doituongSelect.Modified = new Date();
    this.doituongSelect.ModifiedBy = this.currentUser.user_name;

    
    if (this.doituongSelect.SoGiayPhep == null || this.doituongSelect.SoGiayPhep == "") {
      swal('Lỗi!', 'Vui lòng nhập số giấy phép!.', 'error');
      return;
    }
    if (this.doituongSelect.NgayCap == null) {
      swal('Lỗi!', 'Vui lòng nhập ngày cấp!.', 'error');
      return;
    }
    if (this.doituongSelect.DonViCapId == null) {
      swal('Lỗi!', 'Vui lòng nhập đơn vị cấp giấy phép!.', 'error');
      return;
    }
    if (this.doituongSelect.DonViId == null) {
      swal('Lỗi!', 'Vui lòng nhập đơn vị được cấp giấy phép!.', 'error');
      return;
    }

    
    if (this.doituongSelect.Loai == null) {
      swal('Lỗi!', 'Vui lòng nhập nhóm giấy phép!.', 'error');
      return;
    }
    if (this.doituongSelect.LoaiGiayPhepId == null) {
      swal('Lỗi!', 'Vui lòng nhập loại giấy phép!.', 'error');
      return;
    }
    
    //if (this.doituongSelect.Ten == null || this.doituongSelect.Ten == "") {
    //  swal('Lỗi!', 'Vui lòng nhập tên tham số!.', 'error');
    //  return;
    //}
    console.log("giay phep");
    console.log(this.doituongSelect);

    this.repo.postRequest("api/giayphep/addorupdate", this.doituongSelect)
      .subscribe(response => {
        console.log(response);
        if (response != null) {
          this.doituongSelect.Id = response;
          this.save.emit(this.doituongSelect);
        }
        else
          swal('Cảnh báo!', response, 'warning');

      });
  }


}

